// removed by extract-text-webpack-plugin
module.exports = {"body":"app-pages-Library-Tax-TaxAssignToItemModal-__TaxAssignToItemModal___2m9_o","dialog":"app-pages-Library-Tax-TaxAssignToItemModal-__TaxAssignToItemModal___10n4h"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Library/Tax/TaxAssignToItemModal/TaxAssignToItemModal.css
// module id = 2197
// module chunks = 0